/** Valida CPF/CNPJ por dígito verificador. Espera uma string só com dígitos. */
export function isValidCpfCnpj(cpfCnpj: string): boolean {
  if (cpfCnpj.length !== 11 && cpfCnpj.length !== 14) {
    return false;
  }

  const isCPF = (cpf: string): boolean => {
    const repetidos = [
      "00000000000",
      "11111111111",
      "22222222222",
      "33333333333",
      "44444444444",
      "55555555555",
      "66666666666",
      "77777777777",
      "88888888888",
      "99999999999"
    ];
    if (repetidos.includes(cpf) || cpf.length !== 11) {
      return false;
    }

    let soma = 0;
    let peso = 10;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i), 10) * peso;
      peso--;
    }
    let resto = 11 - (soma % 11);
    const dig10 = resto === 10 || resto === 11 ? "0" : resto.toString();

    soma = 0;
    peso = 11;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i), 10) * peso;
      peso--;
    }
    resto = 11 - (soma % 11);
    const dig11 = resto === 10 || resto === 11 ? "0" : resto.toString();

    return dig10 === cpf.charAt(9) && dig11 === cpf.charAt(10);
  };

  const isCNPJ = (cnpj: string): boolean => {
    const repetidos = [
      "00000000000000",
      "11111111111111",
      "22222222222222",
      "33333333333333",
      "44444444444444",
      "55555555555555",
      "66666666666666",
      "77777777777777",
      "88888888888888",
      "99999999999999"
    ];
    if (repetidos.includes(cnpj) || cnpj.length !== 14) {
      return false;
    }

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let peso = 2;

    for (let i = tamanho - 1; i >= 0; i--) {
      soma += parseInt(numeros.charAt(i), 10) * peso;
      peso = peso === 9 ? 2 : peso + 1;
    }
    let resto = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resto !== parseInt(digitos.charAt(0), 10)) {
      return false;
    }

    tamanho += 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    peso = 2;
    for (let i = tamanho - 1; i >= 0; i--) {
      soma += parseInt(numeros.charAt(i), 10) * peso;
      peso = peso === 9 ? 2 : peso + 1;
    }
    resto = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resto === parseInt(digitos.charAt(1), 10);
  };

  return cpfCnpj.length === 11 ? isCPF(cpfCnpj) : isCNPJ(cpfCnpj);
}
